import { render, staticRenderFns } from "./ProjectConfigurationFields.vue?vue&type=template&id=d12d1606&scoped=true&"
import script from "./ProjectConfigurationFields.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationFields.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationFields.vue?vue&type=style&index=0&id=d12d1606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12d1606",
  null
  
)

export default component.exports